const config = {
    BaseUrl: enved('BaseUrl'),
    FullApiUrl: enved('FullApiUrl'),
    SocketUrl: enved('SocketUrl'),
    Themename: enved('Themename'),
    ImageUrl: enved('ImageUrl'),
    GoogleTagCode: enved('GoogleTagCode'),
    lovenseToken: enved('lovenseToken'),
    lovensePlatform: enved('lovensePlatform'),
    DefaultLanguage: enved('DefaultLanguage'),
    Version: enved('Version'),
    // Origin of the Sensemakers chat widget host (chatbot service). Empty = widget off.
    ChatWidgetOrigin: enved('ChatWidgetOrigin')
};

export default config;

function enved(key: string): string {
    return import.meta.env[`VITE_${key}`] || '';
}


if(window.loadTagManager){
    window.loadTagManager(window, document, 'script', 'dataLayer', config.GoogleTagCode);
}